import React from 'react';
import {Image} from '../../../../components/image/image';
import {twMerge} from 'tailwind-merge';

interface LinearImageProps {
    src: string;
    width: number;
    height: number;
    alt: string;
    className?: string;
    imageClassName?: string;
    imageContainerClassName?: string;
}

const LinearImage: React.FC<LinearImageProps> = ({
    src,
    height,
    width,
    alt,
    className,
    imageClassName,
    imageContainerClassName,
}) => {
    const style = twMerge(`w-full`, className);
    const imageStyle = twMerge(`h-full w-full object-cover`, imageClassName);
    const imageContainerStyle = twMerge(`bg-white h-full w-full`, imageContainerClassName);
    return (
        <div
            className={style}
            style={{
                background: 'linear-gradient(301.69deg, #6EC8FF 2.62%, #8DE6FF 23.13%, #81E8FF 30.61%, #AEE9FF 41.35%, #FFD5EB 67.72%)',
                padding: 1
            }}>
            <div className={imageContainerStyle}>
                <Image width={width} height={height} src={src} alt={alt} className={imageStyle} />
            </div>
        </div>
    );
};

export default LinearImage;
